import { Component, Vue } from 'vue-property-decorator'
import Loader from '@/components/Loader/index.vue'
import vSelect from 'vue-select'

import { library } from '@fortawesome/fontawesome-svg-core'
import {
	faTrashAlt,
	faClose,
	faFilePdf,
	faArrowRightLong,
	faCheck,
	faGlobe,
	faCircleInfo,
} from '@fortawesome/free-solid-svg-icons'
import {
	faLinkedinIn,
	faInstagram,
	faYoutube,
} from '@fortawesome/free-brands-svg-icons'

import api from '@/helpers/fetch'
import Fuse from 'fuse.js'
import AWS from 'aws-sdk'
import Control from '@/helpers/control'

library.add(
	faTrashAlt,
	faClose,
	faFilePdf,
	faArrowRightLong,
	faCheck,
	faGlobe,
	faLinkedinIn,
	faInstagram,
	faYoutube,
	faCircleInfo,
)

const bucketName = 'portal-profile-image'
const bucketRegion = 'sa-east-1'
const IdentityPoolId = 'sa-east-1:bc7f9ff6-d461-4870-b480-29756e9502e9'
let s3 = null as any

@Component({
	components: {
		Loader,
		vSelect,
	},
})
export default class CreateUser extends Vue {
	form = {
		name: '',
		email: '',
		file: [] as Array<File>,
		group: '',
		password: '',
		passwordRepeat: '',
		imageUrl: '',
		groups: [] as Array<any>,
		blocked: false,
		block_date: null,
		phone_number: '',
	}

	errorMsg = ''

	options = {
		groups: [] as Array<any>,
	}

	loading = false
	saving = false
	savingGroup = false
	deletingImage = false
	savingImage = false
	blocking = false
	control = new Control()

	fuseSearch(options, search) {
		const fuse = new Fuse(options, {
			keys: ['name'],
			shouldSort: true,
			ignoreLocation: true,
		})
		// @ts-ignore
		return search.length
			? fuse.search(search).map(({ item }) => item)
			: options
	}

	async loadGroups() {
		const res = await api.get('/api/groups')
		this.options.groups = []
		this.options.groups.push(...res.data)
	}

	async loadUser() {
		const res = await api.get('/api/users/' + this.$route.params.userId)
		if (res.ok) {
			res.data.groups = res.data.groups.map((group) => {
				group.loading = false
				return group
			})
			Object.assign(this.form, res.data)
		}
	}

	get minBlockDate() {
		return new Date()
	}

	clearBlockDate() {
		this.form.block_date = null
		this.save('block_date', this.form.block_date)
	}

	successToast() {
		this.$bvToast.toast('Usuário Atualizado!', {
			title: 'Sucesso!',
			variant: 'success',
			solid: true,
			toaster: 'b-toaster-top-center',
		})
	}

	errorToast() {
		this.$bvToast.toast(
			'Tivemos um erro, entre em contato com a area de T.I.',
			{
				title: 'Erro',
				variant: 'danger',
				solid: true,
				toaster: 'b-toaster-top-center',
			},
		)
	}

	awsSetup() {
		AWS.config.update({
			region: bucketRegion,
			credentials: new AWS.CognitoIdentityCredentials({
				IdentityPoolId: IdentityPoolId,
			}),
		})

		s3 = new AWS.S3({
			apiVersion: '2006-03-01',
			params: { Bucket: bucketName },
		})
	}

	uploadImage(callback) {
		if (!(this.form.file instanceof File)) {
			return
		}

		// userid_timestamp-randomString_originalFilename
		const fileName =
			this.$route.params.userId +
			'_' +
			Date.now() +
			'-' +
			Math.round(Math.random() * 1e5) +
			'_' +
			this.form.file.name

		s3.upload(
			{
				Bucket: bucketName,
				Key: fileName,
				Body: this.form.file,
				ContentType: this.form.file.type,
			},
			(err, data) => {
				/**
				 * data: {
				 *   Bucket, (bucket name)
				 *   ETag, (random string)
				 *   Key, (filename)
				 *   Location, (full url)
				 *   key, (filename)
				 * }
				 */
				if (err) {
					this.errorToast()
				} else {
					callback(data.Location)
				}
			},
		)
	}

	onInput(name, value) {
		const debouncedChange = this.control.debounce(() => {
			this.save(name, value)
		}, 1000)
		debouncedChange()
	}

	async save(name, value) {
		const update = {}
		update[name] = value
		this.saving = true
		const res = await api.post(
			'/api/users/' + this.$route.params.userId,
			update,
		)
		this.saving = false

		if (res.ok) {
			this.successToast()
		} else {
			this.errorToast()
		}
	}

	async updateStatus() {
		const payload = { status: !this.form.blocked }
		this.blocking = true
		const res = await api.post(
			'/api/users/' + this.$route.params.userId + '/status',
			payload,
		)
		this.blocking = false

		if (res.ok) {
			this.form.blocked = payload.status
		} else {
			this.errorToast()
		}
	}

	async saveImage() {
		this.savingImage = true
		this.uploadImage(async (imageUrl) => {
			const res = await api.post(
				'/api/users/' + this.$route.params.userId,
				{ imageUrl },
			)
			if (res.ok) {
				this.form.imageUrl = imageUrl
				this.successToast()
			} else {
				this.errorToast()
			}
			this.savingImage = false
		})
	}

	async deleteImage() {
		this.deletingImage = true
		const res = await api.post('/api/users/' + this.$route.params.userId, {
			imageUrl: '',
		})
		if (res.ok) {
			this.form.imageUrl = ''
			this.successToast()
		} else {
			this.errorToast()
		}
		this.deletingImage = false
	}

	async addGroup() {
		if (!this.form.group) return
		const group = this.options.groups.find(
			(group) => group.id === this.form.group,
		)

		this.savingGroup = true
		const res = await api.post(
			'/api/users/' + this.$route.params.userId + '/group',
			{ group: this.form.group },
		)
		if (res.ok) {
			this.form.groups.push({
				mapId: res.data.id,
				name: group.name,
				id: group.id,
				loading: false,
			})
			this.form.group = ''
		} else {
			this.$bvToast.toast(
				'Não foi possível associar grupo, verifique se o grupo já não está associado',
				{
					title: 'Erro',
					variant: 'danger',
					solid: true,
					toaster: 'b-toaster-top-center',
				},
			)
		}
		this.savingGroup = false
	}

	async removeGroup(group, index) {
		group.loading = true
		const res = await api.delete(
			'/api/users/' + this.$route.params.userId + '/group',
			{ mapId: group.mapId },
		)
		if (res.ok) {
			this.form.groups.splice(index, 1)
		}
		group.loading = false
	}

	async submitPassword() {
		if (this.form.password === '') {
			this.errorMsg = 'Por favor, preencha uma senha'
			return
		}

		if (this.form.password !== this.form.passwordRepeat) {
			this.errorMsg = 'As senhas não coincidem'
			return
		}

		this.loading = true
		const res = await api.post(
			'/api/users/' + this.$route.params.userId + '/password',
			{ password: this.form.password },
		)
		this.loading = false

		if (res.ok) {
			this.successToast()
			this.form.password = ''
			this.form.passwordRepeat = ''
		} else {
			this.errorToast()
		}
	}

	async sendInvite() {
		this.loading = true
		const res = await api.post(
			'/api/users/' + this.$route.params.userId + '/invite',
			{},
		)
		this.loading = false

		if (res.ok) {
			this.$bvToast.toast('Convite Enviado!', {
				title: 'Sucesso!',
				variant: 'success',
				solid: true,
				toaster: 'b-toaster-top-center',
			})
		} else {
			this.errorToast()
		}
	}

	async mounted() {
		this.loading = true
		await this.loadUser()
		await this.loadGroups()
		this.loading = false
		this.awsSetup()
	}

	beforeDestroy() {
		s3 = null
	}
}
